import { Box, Button, TextField } from '@material-ui/core';
import OptionsPopup from '../OptionsPopup';
import React, { useEffect, useMemo, useRef, useState } from 'react';
import throttle from 'lodash/throttle';

const EntitySelector = ({
                          label,
                          onChange,
                          onSave,
                          onSaveEmpty,
                          onSaveSuccess,
                          onCancel,
                          renderOption,
                          renderSelectedLabel,
                          popupPlacement,
                        }) => {
  const inputRef = useRef();
  const [saved, setSaved] = useState(true);
  const [inputValue, setInputValue] = useState('');
  const [selectedItem, setSelectedItem] = useState(null);
  const [saving, setSaving] = useState(false);
  const [options, setOptions] = useState([]);

  const search = useMemo(() => {
    return throttle(async (inputValue, setOptions) => {
      onChange(inputValue).then(result => setOptions(result));
    }, 1000);
  }, []);

  const handleChange = async (e) => {
    setInputValue(e.target.value);
    setSaved(false);
  };

  const reset = () => {
    setTimeout(() => {
      setOptions([]);
      setInputValue('');
    }, 100);
  };

  useEffect(() => {
    if (inputValue.length < 2) {
      setOptions([]);
      return;
    }

    search(inputValue, (results) => setOptions(results));
  }, [inputValue]);

  return (
    <form>
      <TextField
        sx={{ width: 210 }} ref={inputRef} label={label} type='text'
        focused={saved}
        size='small'
        InputLabelProps={{ shrink: true }}
        onChange={handleChange}
        onFocus={() => setSelectedItem(null)}
        onBlur={() => reset()}
        value={selectedItem ? renderSelectedLabel(selectedItem) : inputValue}
        autoFocus
      />
      <OptionsPopup opened={options?.length > 0 && selectedItem === null}
                    placement={popupPlacement}
                    list={options} anchorEl={inputRef.current}
                    onSelect={(item) => {
                      inputRef.current.blur();
                      setSelectedItem(item);
                    }}
                    renderOption={(item) => renderOption(item)}
      />
      <Button
        disabled={saving}
        size='large'
        type='button'
        onClick={async () => {
          setSaving(true);
          try {
            if (selectedItem === null && onSaveEmpty !== undefined) {
              await onSaveEmpty(inputValue);
              return;
            }

            await onSave(selectedItem);
            setSelectedItem(null);
            setSaving(false);
            setSaved(true);
            onSaveSuccess(selectedItem);
          } catch (e) {
            setSaving(false);
          }
        }}
      >
        Salvar
      </Button>
      <Button
        size='large'
        type='button'
        color='error'
        onClick={() => onCancel()}>
        Cancelar
      </Button>
    </form>
  );
};

export default EntitySelector;
